import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as common from '../common'

import type { TypeParams } from './types'

export default ec.associations
  .withAliases({
    forEntry: (index: number) => `mappingEntry${index}`,
  })
  .create<TypeParams>(function (rule) {
    // Adjustment label
    this.select({
      collection: ec.Name.Predefined.RateAdjustmentLabel,
      id: rule.mapping?.adjustmentLabel,
      update: (updatedRule, updatedId) => {
        const mapping = updatedRule.mapping ?? { entries: [] }
        updatedRule.mapping = {
          ...mapping,
          adjustmentLabel: updatedId,
        }
      },
    })
    if (rule.mapping) {
      rule.mapping.entries.forEach((_, i) =>
        this.nest({
          alias: this.aliases.forEntry(i),
          extract: ({ mapping }) => mapping?.entries[i],
          use: function (entry) {
            if (entry) {
              // Exclusion label
              this.select({
                collection: ec.Name.Predefined.RateExclusionLabel,
                id: entry.exclusionLabel,
                update: (updatedEntry, updatedId) => {
                  if (updatedEntry) {
                    updatedEntry.exclusionLabel = updatedId
                  }
                },
              })
              const { categoryId, subcategoryId } =
                entry.faFunctionCategorization
                  ? ents.extra.common.FaFunction.Categorization.Ids.from(
                      entry.faFunctionCategorization,
                    )
                  : {}
              // IDC category
              this.select({
                collection: ec.Name.Predefined.IdcFunctionCategory,
                id:
                  categoryId ??
                  (entry.exclusionLabel !== undefined
                    ? common.DEFERRED_EXCLUSION_CATEGORY_ID
                    : undefined),
                update: (updatedEntry, updatedId) => {
                  if (updatedEntry) {
                    updatedEntry.faFunctionCategorization =
                      updatedId === undefined
                        ? undefined
                        : {
                            // NOTE: we are just going to hope that the category ID is valid.
                            // After all, it is pretty unlikely that it is invalid since this
                            // should come directly from the IDC function entity collection
                            categoryId:
                              updatedId as ents.extra.common.FaFunction.Category.Id,
                          }
                  }
                },
              })
              // IDC subcategory
              this.select({
                collection: ec.Name.Predefined.IdcFunctionSubcategory,
                id: subcategoryId,
                update: (updatedEntry, updatedId) => {
                  if (updatedEntry) {
                    updatedEntry.faFunctionCategorization =
                      updatedEntry.faFunctionCategorization && {
                        // We need to convert to plain IDs, since we are going to add
                        // the subcategoryId
                        ...ents.extra.common.FaFunction.Categorization.Ids.from(
                          updatedEntry.faFunctionCategorization,
                        ),
                        // NOTE: we are just going to hope that the category ID is valid.
                        // After all, it is pretty unlikely that it is invalid since this
                        // should come directly from the IDC function entity collection
                        subcategoryId:
                          updatedId as ents.extra.common.FaFunction.Subcategory.Id,
                      }
                  }
                },
              })
            }
          },
        }),
      )
    }
  })
